import { render, staticRenderFns } from "./bank-details.vue?vue&type=template&id=e1ec217e&lang=pug&"
import script from "./bank-details.vue?vue&type=script&lang=js&"
export * from "./bank-details.vue?vue&type=script&lang=js&"
import style0 from "./bank-details.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCol,VForm,VRow,VTextField})


/* hot reload */
if (module.hot) {
  var api = require("/home/udo/Projects/nakami/gvl/gvl-neustart/gvl-neustart-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e1ec217e')) {
      api.createRecord('e1ec217e', component.options)
    } else {
      api.reload('e1ec217e', component.options)
    }
    module.hot.accept("./bank-details.vue?vue&type=template&id=e1ec217e&lang=pug&", function () {
      api.rerender('e1ec217e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/bank-details.vue"
export default component.exports